<template>
  <div>
    <!-- 视频显示区域： -->
    <!--点赞+打赏  -->
    <div class="praise-container">
      <div class="praise" v-if="isReward || isLike">
        <p class="heartBox fontSize12" v-if="isLike">
          <a class="reward">
            <img :src="require('@/svg/prise.svg')" width="16px"/>
            <span class="count">{{ praiseCount }}</span>
          </a>
        </p>
        <p class="fontSize12" v-if="isReward">
          <el-tooltip :content="$t('priseReward.打赏明细')" placement="bottom-start">
            <a @click="getRewardList" href="javascript:;" class="reward">
              <img :src="require('@/svg/rewards.svg')" width="16px"/>
              <span class="count">{{rewardCount}}</span>
              <img :src="require('@/svg/reward_go.svg')" class="go-img" width="5px"/>
            </a>
          </el-tooltip>
        </p>
      </div>
      <el-divider direction="vertical" v-if="isReward || isLike"></el-divider>
      <!-- <span class="line"></span> -->
    </div>
    <rewardList :reward="showRewardList" @totalWard="totalWard" ref="reward" />

  </div>

</template>

<script>
import rewardList from '@/components/reward/list';
import { getWebcastCount } from '@/api/liveRequest/chatApi';
import { pushRoomMessageFunc, removeMessageFunc } from '@/utils/socketMessageDispose';

export default {
  name: 'priseReward',
  components: {
    rewardList
  },
  data() {
    return {
      showRewardList: false,
      praiseCount: 0,
      rewardCount: 0
    };
  },
  watch: {
    liveToken: {
      immediate: true,
      handler(value) {
        console.log(value, 'token');
        this.getWebcastCount();
        setTimeout(() => {
          this.$refs.reward.rewardslists();
        }, 1000);
      }
    }
  },
  computed: {
    guestSeeAuth() {
      return this.$store.getters.guestSeeAuth;
    },
    role() {
      //3:主播 2：助手 1：嘉宾
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.type;
    },

    curAvctl() {
      return (
        this.$store.getters.JoinedList &&
        this.$store.getters.JoinedList.find((info) => {
          return info.avctl == 1;
        })
      );
    },
    curShare() {
      return (
        this.$store.getters.JoinedList &&
        this.$store.getters.JoinedList.find((info) => {
          return info.share == 1;
        })
      );
    },

    liveToken() {
      return this.$store.getters.liveToken;
    },
    isReward() {
      return this.$store.state.liveInfo.liveConfig.is_reward;
    },
    isLike() {
      return this.$store.state.liveInfo.liveConfig.is_like;
    }
  },
  created() {},
  methods: {
    getRewardList() {
      this.showRewardList = true;
    },
    getWebcastCount() {
      getWebcastCount({ webcastId: this.$route.query.liveId }, this.liveToken)
        .then((res) => {
          if (res.code === 200) {
            this.praiseCount = res.data.praiseCount;
            this.$store.commit('SET_PRAISECOUNT', this.praiseCount);
          }
        })
        .catch((err) => {
          console.log(err, 'err_getWebcastCount');
        });
    },
    getCvMcRoomMessage(msg) {
      switch (msg.cmd) {
        case 7107: {
          this.disposeCustomMessage_7107(msg.requestData);
          break;
        }
      }
    },
    disposeCustomMessage_7107(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case 'praise':
            this.praiseCount = requestData.praiseCount;

            this.$store.commit('SET_PRAISECOUNT', this.praiseCount);
            break;
          case 'giftEvent':
            if (requestData.price !== '0') {
              this.$refs.reward.rewardslists();
            }
            break;
        }
      }
    },
    totalWard(total) {
      this.rewardCount = total > 0 ? (total / 100).toFixed(2) : 0;
      this.$store.commit('SET_REWARDCOUNT', this.rewardCount);
    }
  },
  beforeDestroy() {
    removeMessageFunc(this.getCvMcRoomMessage);
  },
  mounted() {
    pushRoomMessageFunc(this.getCvMcRoomMessage);
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/vars';
.reward {
  color: #8A8F99;
  text-decoration: none;
  display: flex;
}
.count {
  display: flex;
  align-items: center;
}
.praise-container {
  display: flex;
  align-items: center;
  .praise {
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #8A8F99;
    margin-right: 8px;
  }
  img {
    margin-right: 2px;
  }
  .go-img {
    margin-left: 5px;
  }
}
.heartBox {
  margin-right: 15px;
}
.praise-container {

}
[data-theme=Orange] .el-divider {
  background-color: #ccc !important;
}
</style>
